import { styled } from "@mui/material";
import { Link } from "react-router-dom";

export const StyledLink = styled(Link) (({theme}) => ({
    textDecoration: "none",
    color: theme.palette.secondary.light,
    fontWeight: theme.typography.fontWeightBold
}))